// import { useState } from "react";
import { Link } from "react-router-dom";
// import edit from "../../images/edit.png";
import { GetInsumos } from "../../actions/Insumo";
import { GotoLogin } from "../../actions/renovarLog";
import { useMutation } from "@tanstack/react-query";
// import ImagenCerrar from "../../images/cerrar.png";
import {
   Pencil,
   SquareX,
   CirclePlus,
   Grid3x3,
   ShoppingCart,
} from "lucide-react";
import style from "../../styles/grid.module.css";
import exportToExcel from "../../actions/exportexcel";

const Insumos = () => {
   const token = localStorage.getItem("token");
   const url = process.env.REACT_APP_URL_DIR + "insumo";
   // const [nombre, setName] = useState("");
   const insumos = GetInsumos();

   // const { mutate: getNombre } = useMutation({
   //    mutationFn: (nombre) =>
   //       fetch(`${url}?nombre=${nombre}`, {
   //          method: "GET",
   //          // body: JSON.stringify(newPost),
   //          headers: {
   //             Authorization: `Bearer ${token}`,
   //             "Content-Type": "application/json",
   //          },
   //       }).then((res) => res.json()),
   //    onSuccess: () => {
   //       //  setData(data)
   //       //window.location.href = "/clientes";
   //    },
   //    onError: () => {
   //       alert("Error");
   //    },
   // });

   const { mutate: delInsumo } = useMutation({
      mutationFn: (id) =>
         fetch(url + "/" + id, {
            method: "DELETE",
            body: JSON.stringify(),
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: () => {
         window.location.href = "/Insumos";
      },
      onError: () => {
         alert("Error");
      },
   });

   // function handleInputChange(e) {
   //    if (e.key === "Enter") {
   //       console.log("nombre: ", nombre);
   //       setName("");
   //    }
   // }
   const handleRemove = (id) => {
      let text =
         "Se va a eliminar el Insumo selecionado!\nSelecione Aceptar or Cancelar.";
      if (window.confirm(text) === true) {
         delInsumo(id);
      }
   };
   if (insumos?.message === "Token inválido") {
      return <GotoLogin />;
   }
   console.log("insumos: ", insumos);
   //  console.log('window.innerWidth: ', window.innerWidth);
   return (
      <>
         <div className={style.tableCli}>
            <div className={style.header}>
               <div className={style.gridTitle}>
                  <h2>Insumos Piercing</h2>
               </div>
               {/* <div className={style.divBuscar}>
                  <label htmlFor="search-navbar">Buscar:&nbsp;</label>
                  <input
                     className={style.inputBuscar}
                     onKeyPress={(e) => handleInputChange(e)}
                     onChange={(e) => setName(e.target.value)}
                     type="text"
                     id="search-navbar"
                     placeholder="Buscar..."
                     value={nombre}
                  />
               </div> */}
               <div>
                  <Link
                     to={"/formInsumo"}
                     className="dLink"
                     title="Alta Insumo"
                     state={{
                        id_primary: 0,
                        id: 0,
                        companyId: 0,
                        descripcion: "",
                        dolar: 0,
                        cod_status: 1,
                        tipo: 1,
                        stock: 0,
                     }}
                  >
                     <CirclePlus className="lucidePlus" />
                     {/* <button className={style.inputBtnServ}>Nuevo Insumo</button> */}
                  </Link>
                  &nbsp;&nbsp;
                  <Grid3x3
                     className="lucideExcel"
                     title="Exportar a Excel"
                     onClick={() => exportToExcel(insumos, "insumos")}
                  />
               </div>
            </div>
            <div>
               <table className={style.gridTable}>
                  <thead>
                     <tr>
                        {/* <th className={style.style_titulos}>ID</th> */}
                        <th>Descripcion</th>
                        <th>Presentacion</th>
                        <th>Unidad de medida</th>
                        <th>Presentacion</th>
                        <th>Consumo</th>
                        <th className={style.style_titulos}>Stock</th>
                        <th className={style.style_titulos}>
                           Precio por Unidad
                        </th>
                        <th className={style.tdaccions}>Acciones</th>
                     </tr>
                  </thead>
                  <tbody>
                     {insumos &&
                        insumos?.map((insu) => {
                           var muestroreg = true;
                           // if (nombre!==""){
                           //    if (insu.descripcion.toUpperCase().includes(nombre.toUpperCase())){
                           //       muestroreg=true
                           //    } else {
                           //       muestroreg=false
                           //    }
                           // }
                           if (parseInt(insu.tipo) === 2) {
                              // es insumo de tattoo
                              muestroreg = false;
                           }
                           var medDes = "Unidad";
                           if (insu.unimed === 2) medDes = "Mililitros";
                           if (insu.unimed === 3) medDes = "Gramos";
                           if (insu.unimed === 4) medDes = "Metros";

                           if (muestroreg) {
                              return (
                                 <tr
                                    key={insu.id}
                                    className={
                                       parseInt(insu.cod_status) === 2
                                          ? style.trdatosRed
                                          : style.trdatos
                                    }
                                 >
                                    {/* <td className={style.style_code}>{insu.id}</td> */}
                                    <td className={style.style_td}>
                                       {insu.descripcion}
                                    </td>
                                    <td className={style.style_td}>
                                       {insu.presdescrip}
                                    </td>
                                    <td className={style.style_td}>{medDes}</td>
                                    {insu.unimed === 1 ? (
                                       <td colSpan={2}>&nbsp;</td>
                                    ) : (
                                       <>
                                          <td className={style.style_precio}>
                                             {insu.presentacion}
                                          </td>
                                          <td className={style.style_precio}>
                                             {insu.consumo}
                                          </td>
                                       </>
                                    )}

                                    <td className={style.style_precio}>

                                       {insu.unimed === 1 ? parseInt(insu.stock) : insu.stock}&nbsp;&nbsp;&nbsp;
                                    </td>
                                    <td className={style.style_precio}>
                                       {insu.dolar}&nbsp;$&nbsp;&nbsp;
                                    </td>
                                    <td className={style.tdaccions}>
                                       <Link
                                          to={"/formInsumo"}
                                          className="dLink"
                                          state={{
                                             id_primary: insu.id_primary,
                                             id: insu.id,
                                             companyId: insu.companyId,
                                             descripcion: insu.descripcion,
                                             presdescrip: insu.presdescrip,
                                             dolar: insu.dolar,
                                             stock: insu.stock,
                                             unimed: insu.unimed,
                                             presentacion: insu.presentacion,
                                             consumo: insu.consumo,
                                             tipo: insu.tipo,
                                             cod_status: insu.cod_status,
                                          }}
                                       >
                                          <Pencil className="lucideIcon" />
                                          {/* <img src={edit} height="30px" alt="" title="Editar insumo" /> */}
                                          {/* <FcAcceptDatabase style={estilo} /> */}
                                       </Link>
                                       &nbsp;&nbsp;
                                       <Link
                                          to={"/reporteCompra"}
                                          className="dLink"
                                          title="Listado Compra"
                                          state={{
                                             id_primary: insu.id_primary,
                                             id: insu.id_primary,
                                          }}
                                       >
                                          <ShoppingCart />
                                       </Link>
                                       &nbsp;&nbsp;
                                       <span
                                          title="Eliminar"
                                          className="lucideIconDel"
                                          onClick={() => handleRemove(insu.id)}
                                       >
                                          <SquareX className="lucideIconDel" />
                                       </span>
                                       {/* <img
                                       onClick={() => handleRemove(insu.id)}
                                       src={ImagenCerrar}
                                       height="30px"
                                       alt=""
                                       title="Eliminar insumo" 
                                    /> */}
                                    </td>
                                 </tr>
                              );
                           } else {
                              return null;
                           }
                        })}
                  </tbody>
               </table>
            </div>
         </div>
      </>
   );
};

export default Insumos;
